
export const UTIL_MENU = [
    { path: "news", name: "Noticias", icon: "ico_notice", click: true, childs: [{ path: "adviser", name: "Asesor", icon: "ico_acessor" }, { path: "customer", name: "Cliente", icon: "ico_customer" }] },
    { path: "ourCompany", name: "Nuestra compañía", click: false, icon: "ico_company", childs: [] },
    // { path: "notification", name: "Notificaciones", click: false, icon: "ico_notification", childs: [{ path: "custom", name: "Personalizada", icon: "ico_objective_user" }, { path: "generic", name: "Genérica", icon: "ico_generic" }] },
     { path: "files", name: "Carga de archivos", click: false, icon: "ico_upload_file", childs: [] },
     { path: "cotizador", name: "Cotizador", click: false, icon: "ico_upload_file", childs: [] }
];

export class Constant{
    public static idNewsTypeAsesor = 3952;
    public static idNewsTypeCliente = 3953;
}

export const UTIL_BUSINESS_LINE: Record<string, string> = {
  '1': 'MP',
  '2': 'SAO',
  '3': 'CEM'
};